import "./../styles.scss";

import { LoadingOutlined } from "@ant-design/icons";
import { Menu, Select } from "antd";
import { notification, Pagination, Spin } from "antd";
import { Delete } from "components/icons";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useOutletContext } from "react-router-dom";
import { convertIsoDateToStandardFormat } from "utils/date";
import UploadCSVModal from "views/Configuration/partials/UploadCSVModal";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import ManageAccess from "../../../components/common/ManageAccess/manageAccess";
import DeleteModal from "../../../components/common/Modals/component";
import CloseModal from "../../../components/icons/CloseModal";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import amplitude from "../../../externals/amplitude";
import { addEventValidation } from "../../../utils/validations";
const { Option } = Select;

const AddEvent = (props) => {
  const {
    createEvent,
    loder,
    settingsRecordsPerPage,
    addTagThroughCSV,
    getAllCategory,
    getAllTagsById,
    deleteTagsById,
    selectedCategories,
    getEntityTypes,
    id,
    ENTITY_TYPE,
  } = props;
  const [modalIsOpen, setIsOpen] = useState(false);
  const [event, setEvent] = useState("");
  const [keyMoments, setKeyMoments] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [delmodalOpen, setDeleteModalOpen] = useState(false);
  const [eventLoder, setEventLoder] = useState(false);
  const [csvmodalIsOpen, setcsvIsOpen] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [allCategory, setAllCategory] = useState([]);
  const { user, clientSetting, entityId } = useOutletContext();
  const [selectCategory, setSelectCategory] = useState("");

  useEffect(() => {
    getEventByCategory(allCategory[0]?.name);
    setSelectCategory(allCategory[0]?.name);
  }, [allCategory]);

  const handlePageChange = (current) => {
    setActivePage(current);
    amplitude.logEvent("event_pagination", { page: current });
  };
  const tableAction = (data) => (
    <Menu
      items={[
        {
          label: (
            <a
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                delOpen(data);
              }}
            >
              <DeleteIcon />
              <span>Delete</span>
              {loder == false ? (
                ""
              ) : (
                <Spin
                  size="large"
                  indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                  className="loader__full"
                ></Spin>
              )}
            </a>
          ),
          key: "0",
          disabled: data?.entityId !== id,
        },
      ]}
    />
  );
  const delOpen = (id) => {
    setDeleteId(id);
    setDeleteModalOpen(true);
  };

  const delclose = () => {
    setDeleteModalOpen(false);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const deleteEventModal = async () => {
    setEventLoder(true);
    const { value } = await deleteTagsById({
      _id: deleteId?._id,
      entityId: id,
    });
    if (value?.success) {
      notification["success"]({ message: value.message });
    } else {
      notification["error"]({ message: value.message });
    }

    await getEventByCategory(event);
    setEventLoder(false);
    handlePageChange(1);
    delclose();
    amplitude.logEvent("event_deleted", { category: event });
  };

  const [initialState, setInitialState] = useState({
    event: "",
    keyMoment: "",
  });

  const getEventByCategory = async (event) => {
    setEvent(event);
    const categoryId = (await allCategory) && allCategory?.filter((data) => data.name == event);
    if (categoryId.length > 0) {
      const { value } = await getAllTagsById({
        category: categoryId[0].name,
        tagType: "event",
        entityId: id,
        limit: 20,
        pageNo: activePage,
      });
      if (value.success) {
        console.log(value);
        setKeyMoments(value);
      } else {
        setKeyMoments([]);
      }
    }
    amplitude.logEvent("event_category_selected", { category: event });
  };
  const handleSubmit = async ({ event, keyMoment }) => {
    const categoryId = allCategory && allCategory.filter((data) => data.name == event);
    await createEvent({
      name: keyMoment,
      category: categoryId[0]?.name,
      tagType: "event",
      entityId: id,
      createdBy: user?._id,
    });
    closeModal();
    getEventByCategory(event);
    amplitude.logEvent("event_added", { category: event, name: keyMoment });
  };

  const openCSVModal = () => {
    setcsvIsOpen(true);
    amplitude.logEvent("upload_event_csv_clicked");
  };

  const closeCSVModal = () => {
    setcsvIsOpen(false);
  };

  const onFileDrop = async (files) => {
    let data = new FormData();
    data.append("file", files[0]);
    data.append("entityId", id);

    //call api here
    const { value } = await addTagThroughCSV(data);
    value.success
      ? notification[value?.warning ? "warning" : "success"]({
          message: value?.warning ? value?.warning : "Events added successfully!",
        })
      : notification["error"]({ message: value.message });
    setcsvIsOpen(false);
    getEventByCategory(event);
    amplitude.logEvent("event_csv_uploaded");
  };

  const openModal = () => {
    setInitialState({ ...initialState, event: event });
    setIsOpen(true);
    amplitude.logEvent("add_event_clicked");
  };
  const getAllCategorys = async () => {
    if (id) {
      const { value } = await getAllCategory({
        entityId: id,
      });
      if (value?.success) {
        let assignCategories = value?.data?.filter((data) => selectedCategories?.includes(data?.name));
        setAllCategory(assignCategories || []);
      }
    }
  };

  useEffect(() => {
    if (selectedCategories) getAllCategorys();
  }, [user, selectedCategories]);
  useEffect(() => {
    getEventByCategory(selectCategory);
  }, [activePage, selectCategory]);
  const handleSelectCategory = (e) => {
    getEventByCategory(e);
    setSelectCategory(e);
    setActivePage(1);
  };
  return (
    <>
      <DeleteModal
        deleteComanModel={deleteEventModal}
        modalIsOpen={delmodalOpen}
        setDeleteModalOpen={setDeleteModalOpen}
        loder={eventLoder}
        header="Delete"
        content="Are you sure you want to delete?"
      />

      <UploadCSVModal
        csvmodalIsOpen={csvmodalIsOpen}
        closeCSVModal={closeCSVModal}
        loader={loder}
        url={"https://test-fancode.s3.amazonaws.com/tags.csv"}
        onFileDrop={onFileDrop}
      />
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered filter-modal"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Add Event For Sport</h5>
            <button type="button" onClick={closeModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <Formik initialValues={initialState} validationSchema={addEventValidation} onSubmit={handleSubmit}>
            {({ errors, touched, setFieldValue }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="field-items mb-4">
                      <label className="form-label">
                        {" "}
                        Category <span className="required">*</span>
                      </label>
                      <div className="form-pop-trigger-block">
                        <Field
                          showSearch
                          className="custom-ant-select"
                          name="event"
                          onChange={(value) => setFieldValue("event", value)}
                          component={Select}
                          dropdownStyle={{ zIndex: 99999999 }}
                          // placeholder="Select Sport"
                          defaultValue={event || "Select Category"}
                        >
                          {allCategory.length &&
                            allCategory.map((data, index) => {
                              return (
                                <>
                                  <Option key={data?._id} value={data.name}>
                                    {data?.displayName}
                                  </Option>
                                </>
                              );
                            })}
                        </Field>
                      </div>
                    </div>
                    <div className="field-items mb-4">
                      <label className="form-label">
                        Event Name <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="keyMoment" type="text" placeholder="Enter Event Name" />
                      {touched.keyMoment && errors.keyMoment && (
                        <div className="invalid-feedback">{errors.keyMoment}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      <button type="button" className="btn btn-white" onClick={closeModal}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Add
                        {loder && (
                          <Spin
                            size="large"
                            indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                            className="loader__full"
                          ></Spin>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>

      <div className="col-md-12">
        <div className="border-block groups-block">
          <div className="left-block">
            <h4 className="title-sm-t">Events</h4>
            <p>Entertainment, Sports, News</p>
          </div>
          <div className="right-btn-block">
            <AccessControl code="add_event" page="organization-profile">
              <ManageAccess value={getEntityTypes(id) !== ENTITY_TYPE.WORKSPACES}>
                <div class="button-container">
                  <button class="btn btn-white me-3" onClick={openCSVModal}>
                    Upload a CSV file
                  </button>
                  <button class="btn btn-primary" onClick={openModal}>
                    Add Events
                  </button>
                </div>
              </ManageAccess>
            </AccessControl>
          </div>
        </div>
        <br />
        <div>
          <div className="field-items mb-4">
            <label className="form-label"> Select Category </label>
            <Select
              className="custom-ant-select"
              value={event}
              showSearch
              placeholder="Select Sport"
              onChange={handleSelectCategory}
            >
              {allCategory?.length &&
                allCategory?.map((data, index) => {
                  return (
                    <>
                      <Option key={data?._id} value={data.name}>
                        {data?.displayName}
                      </Option>
                    </>
                  );
                })}
            </Select>
          </div>
        </div>
        <div className="configuration-items-row mt-5 row">
          <div className="col-md-12">
            <h5 className="title-small">Added Events</h5>
          </div>

          {keyMoments &&
            keyMoments?.tag?.map((data) => {
              return (
                <>
                  <div className="col-md-2">
                    <div className="confi-block-col-container configuration-column flex-column gap-0 p-2">
                      <div className="confi-block-col">
                        <h4 className="word-break-common">
                          {data.name
                            .split(" ")
                            .map((letter, index) => letter.charAt(0).toUpperCase() + letter.slice(1).toLowerCase())
                            .join(" ")}
                        </h4>
                        <h6>{convertIsoDateToStandardFormat(data?.createdAt)}</h6>
                      </div>
                      {/* <AccessControl code="delete_event" page="configuration">
                        <ManageAccess value={data?.organizationId == entityId}>
                          <Dropdown
                            className=""
                            overlay={tableAction(data)}
                            trigger={["click"]}
                            overlayClassName={"tableActionBlock"}
                            placement={"bottomRight"}
                          >
                            <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                              <TdiVerticalDark />
                            </a>
                          </Dropdown>
                        </ManageAccess>
                      </AccessControl> */}
                      {/* <div className="icon-block">
                        <VideoGroup />
                      </div> */}

                      <div className="action-buttons gap-3">
                        <AccessControl code="delete_event" page="organization-profile">
                          <ManageAccess value={getEntityTypes(id) !== ENTITY_TYPE.WORKSPACES}>
                            <button>
                              <Delete
                                onClick={() => {
                                  delOpen(data);
                                }}
                              />
                            </button>
                          </ManageAccess>
                        </AccessControl>
                      </div>
                      {/* <div className="btn-action">
                        <button className="btn btn-edit btn-primary">Edit</button>
                      </div> */}
                    </div>
                  </div>
                </>
              );
            })}
        </div>
        <ManageAccess value={!keyMoments.totalCount > 0}>
          <div className="col-md-12">
            <div className="w-100 text-center py-5">
              <h4>No Data Found!</h4>
            </div>
          </div>
        </ManageAccess>
        <Pagination
          showSizeChanger={false}
          current={activePage}
          pageSize={20}
          onChange={handlePageChange}
          total={keyMoments?.totalCount}
          className="text-center mt-3"
        />
      </div>
    </>
  );
};
export default AddEvent;
